import React from 'react';
import { Modal as DefaultModal } from '../../Modal';
import { useComponentContext } from '../../../context';
export const PollAction = ({ buttonText, children, closeModal, modalClassName, modalIsOpen, openModal, }) => {
    const { Modal = DefaultModal } = useComponentContext();
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: 'str-chat__poll-action', onClick: openModal }, buttonText),
        React.createElement(Modal, { className: modalClassName, onClose: closeModal, open: modalIsOpen }, children)));
};
